<template>
	<pui-datatable v-if="!masterDetail" :modelName="model" :actions="actions" showFilterListBtn></pui-datatable>
	<pui-datatable
		v-else
		:modelName="model"
		:actions="actions"
		:externalFilter="externalFilter"
		:masterDetail="masterDetail"
		:parentModelName="parentModelName"
		:showCreateBtn="false"
		:showDeleteBtn="false"
		:isEditableRegistry="isEditableRegistry"
	></pui-datatable>
</template>

<script>
import PuiGridDetailMixin from 'pui9-mixins/PuiGridDetailMixin';
import HistoricoLibTransActions from './HistoricoLibTransActions';

export default {
	name: 'historicolibtransgrid',
	mixins: [PuiGridDetailMixin],
	data() {
		return {
			model: 'historicolibtrans',
			actions: HistoricoLibTransActions.gridactions
		};
	},
	created() {
		if (this.masterDetail) {
			const parentModel = this.$store.getters.getModelByName(this.parentModelName);
			const thisModel = this.$store.getters.getModelByName(this.model);
			if (parentModel && thisModel) {
				const parentModelPk = this.$puiUtils.getPathModelMethodPk(this.$router, this.parentModelName);
				thisModel.parentModelName = this.parentModelName;
				thisModel.parentModelPk = parentModelPk.pk;
			}
		}
	},
	methods: {
		isEditableRegistry() {
			return false;
		}
	}
};
</script>

<i18n>
{
    "en": {
		"grid.historicolibtrans.idhistorico":"Code",
		"grid.historicolibtrans.idlibramiento":"Order code",
		"grid.historicolibtrans.usralta":"Performer code",
		"grid.historicolibtrans.actor":"Performer",
		"grid.historicolibtrans.idestadoanterior":"Previous state code",
		"grid.historicolibtrans.estadoanterior":"Previous state",
		"grid.historicolibtrans.idestadonuevo":"New state code",
		"grid.historicolibtrans.estadonuevo":"New state",
		"grid.historicolibtrans.lang":"Language",
		"grid.historicolibtrans.idaccion":"Action code",
		"grid.historicolibtrans.accion":"Action",
		"grid.historicolibtrans.idpuntocargaanterior":"Id. Previous loading point",
		"grid.historicolibtrans.puntocargaanterior":"Previous loading point",
		"grid.historicolibtrans.idpuntocarganuevo":"Id. New loading point",
		"grid.historicolibtrans.puntocarganuevo":"New loading point",
		"grid.historicolibtrans.fecha":"Date",
		"grid.historicolibtrans.fechacreacion":"Creation date"
    },
    "es": {
		"grid.historicolibtrans.idhistorico":"Código",
		"grid.historicolibtrans.idlibramiento":"Código encargo",
		"grid.historicolibtrans.usralta":"Código actor",
		"grid.historicolibtrans.actor":"Actor",
		"grid.historicolibtrans.idestadoanterior":"Código estado anterior",
		"grid.historicolibtrans.estadoanterior":"Estado anterior",
		"grid.historicolibtrans.idestadonuevo":"Código estado nuevo",
		"grid.historicolibtrans.estadonuevo":"Estado nuevo",
		"grid.historicolibtrans.lang":"Idioma",
		"grid.historicolibtrans.idaccion":"Código acción",
		"grid.historicolibtrans.accion":"Acción",
		"grid.historicolibtrans.idpuntocargaanterior":"Id. Punto de carga anterior",
		"grid.historicolibtrans.puntocargaanterior":"Punto de carga anterior",
		"grid.historicolibtrans.idpuntocarganuevo":"Id. Punto de carga nuevo",
		"grid.historicolibtrans.puntocarganuevo":"Punto de carga nuevo",
		"grid.historicolibtrans.fecha":"Fecha",
		"grid.historicolibtrans.fechacreacion":"Fecha creación"
	},
    "ca": {
		"grid.historicolibtrans.idhistorico":"Codi",
		"grid.historicolibtrans.idlibramiento":"Codi encàrrec",
		"grid.historicolibtrans.usralta":"Codi actor",
		"grid.historicolibtrans.actor":"Actor",
		"grid.historicolibtrans.idestadoanterior":"Codi estat anterior",
		"grid.historicolibtrans.estadoanterior":"Estat anterior",
		"grid.historicolibtrans.idestadonuevo":"Codi estat nou",
		"grid.historicolibtrans.estadonuevo":"Estat nou",
		"grid.historicolibtrans.lang":"Idioma",
		"grid.historicolibtrans.idaccion":"Codi acció",
		"grid.historicolibtrans.accion":"Acció",
		"grid.historicolibtrans.idpuntocargaanterior":"Id. Punt de càrrega anterior",
		"grid.historicolibtrans.puntocargaanterior":"Punt de càrrega anterior",
		"grid.historicolibtrans.idpuntocarganuevo":"Id. Punt de càrrega nou",
		"grid.historicolibtrans.puntocarganuevo":"Punt de càrrega nou",
		"grid.historicolibtrans.fecha":"Data",
		"grid.historicolibtrans.fechacreacion":"Data creació"
	}
}
</i18n>
